import React from 'react';
import { TextField } from '@mui/material';

const StringInput = ({ label, value, onChange, type = "text" }) => {
  return (
    <div>
    <TextField
      label={label}
      variant="outlined"
      value={value}
      onChange={onChange}
      type={type}
      InputLabelProps={{ shrink: true }} 
    />
    </div>
  );
};

export default StringInput;